import * as React from 'react'

function SvgIconBug(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="bug" aria-labelledby="t-bug d-bug">
        <title id="t-bug">{'Bug'}</title>
        <desc id="d-bug">{'A six-legged bug'}</desc>
        <path d="M31 18h-3v-1c0-1-.1-1.9-.2-2.9l3.7-2.3c.5-.3.6-.9.3-1.4s-.9-.6-1.4-.3L27.2 12c-.2-.7-.5-1.4-.7-2.1H17v21.9c3.2-.3 6.1-2.3 8.1-5.1l3.4 2.1c.5.3 1.1.101 1.4-.3.3-.5.1-1.1-.301-1.4L26.2 25c.8-1.5 1.399-3.2 1.7-5.1H31c.6 0 1-.4 1-1s-.4-.9-1-.9zm-16-8H5.4c-.3.7-.5 1.3-.7 2.1l-3.2-1.9C1 9.9.4 10 .1 10.5c-.2.5-.1 1.1.4 1.4l3.7 2.3C4.1 15.1 4 16 4 17v1H1c-.6 0-1 .4-1 1s.4 1 1 1h3.2c.3 1.8.9 3.5 1.7 5.1l-3.4 2.1c-.5.2-.6.8-.4 1.3.3.5.9.6 1.4.4l3.4-2.1c2 2.9 4.9 4.8 8.1 5.101V10zM6.4 8h19.2c-1.2-2-2.9-3.7-4.7-4.7l1-1.8c.2-.5.1-1.1-.4-1.4-.5-.2-1.1-.1-1.4.4l-1.1 2c-1-.3-2-.5-3-.5s-2 .2-3 .5l-1.1-2c-.3-.5-.9-.6-1.4-.4-.5.3-.6.9-.4 1.4l1 1.8C9.3 4.3 7.6 6 6.4 8z" />
      </g>
    </svg>
  )
}

export default SvgIconBug
